import { createFileRoute } from "@tanstack/react-router";
import { KostenDetailPage, kostenDetailHead } from "../components/KostenDetailPage";
import { kostenDetails } from "../lib/kosten-detail-content";

const detail = kostenDetails["aanbouw-2-verdiepingen-kosten"]!;

export const Route = createFileRoute("/aanbouw-2-verdiepingen-kosten")({
  head: () => kostenDetailHead(detail),
  component: () => <KostenDetailPage detail={detail} />,
});
